import { useState, useEffect } from 'react';

export interface ResponsiveState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isPortrait: boolean;
  isLandscape: boolean;
  width: number;
}

/**
 * 响应式布局检测 Hook
 * 
 * 断点定义:
 * - Mobile: < 768px
 * - Tablet: 768px - 1023px  
 * - Desktop: >= 1024px
 */
export const useResponsive = (): ResponsiveState => {
  const [state, setState] = useState<ResponsiveState>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    isPortrait: true,
    isLandscape: false,
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
  });

  useEffect(() => {
    const checkResponsive = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setState({
        isMobile: width < 768,
        isTablet: width >= 768 && width < 1024,
        isDesktop: width >= 1024,
        isPortrait: height > width,
        isLandscape: width > height,
        width,
      });
    };

    // 初始检测
    checkResponsive();

    // 监听窗口大小变化
    window.addEventListener('resize', checkResponsive);
    
    // 监听方向变化（主要用于移动设备）
    window.addEventListener('orientationchange', checkResponsive);

    return () => {
      window.removeEventListener('resize', checkResponsive);
      window.removeEventListener('orientationchange', checkResponsive);
    };
  }, []);

  return state;
};

export default useResponsive;
